import { ContentBlock } from '../types';

export const OFFICE_USE_BLOCK_MARKER_ID = 'officeUseDate';

export const OFFICE_USE_BLOCK: ContentBlock = {
  type: 'field-group',
  pdfOnly: true,
  pdfTable: true,
  fields: [
    { type: 'text', id: OFFICE_USE_BLOCK_MARKER_ID, label: 'Date' },
    { type: 'text', id: 'officeUseStaffInitials', label: 'Staff Initials' },
    { type: 'text', id: 'officeUseNotes', label: 'Notes' },
    { type: 'text', id: 'officeUseMrnId', label: 'Patient MRN / ID' },
  ],
};

export function isOfficeUseBlock(block: ContentBlock): boolean {
  if (block.type !== 'field-group') return false;
  if (!block.pdfOnly) return false;
  return block.fields[0]?.id === OFFICE_USE_BLOCK_MARKER_ID;
}
